import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './features/store';
// import { ClearCacheProvider } from 'react-clear-cache';

window.store = store;
console.log = () => { };
console.warn = () => { };
console.error = () => { };
console.info = () => { };
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <ClearCacheProvider duration={5000} filename="meta.json"> */}
        <App />
      {/* </ClearCacheProvider> */}
    </Provider>
  </React.StrictMode>
  , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
